export default __webpack_public_path__ + "static/media/img-create.9e37f36d.svg";